"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subtitle = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../constants");
const color_1 = require("../constants/color");
const create_styles_1 = require("../utils/create-styles");
/**
 * @deprecated
 */
exports.Subtitle = styled_1.default.h5((props) => ({
    color: props.color ?? color_1.Color.DARK_GREY,
    fontSize: 13,
    fontWeight: constants_1.theme.font.weight.bold,
    letterSpacing: '0.03rem',
    marginBottom: 8,
    marginTop: 0,
    textTransform: 'uppercase',
    ...(0, create_styles_1.createStyles)(props.styles),
}));
